import { AppDispatch } from './store'
import { CLEAR_REDUCER } from './types'

export const clearReduxAction = (): any => (dispatch: AppDispatch) =>
  dispatch({
    type: CLEAR_REDUCER,
  })
